import { StackIcon } from "@phosphor-icons/react";
import { polishPlurals } from "apps/visits/packages/shared/utils/polish-plurals";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/shared/v2/lib/utils";
import type { BloodTestPackage } from "../../../models";

type BloodTestsCountProps = {
  bloodTests: BloodTestPackage["bloodTests"];
  className?: string;
};

export const BloodTestsCount = ({ bloodTests, className }: BloodTestsCountProps) => {
  const { t } = useTranslation();
  const bloodTestsPlurals = polishPlurals(
    t("COMMONS.VARIATIONS.BLOOD_TESTS.SINGULAR_NOMINATIVE"),
    t("COMMONS.VARIATIONS.BLOOD_TESTS.PLURAL_NOMINATIVE"),
    t("COMMONS.VARIATIONS.BLOOD_TESTS.PLURAL_GENITIVE"),
  );

  return (
    <span className={cn("inline-flex items-center gap-x-1 text-grey-500 text-sm max-lg:font-semibold", className)}>
      <StackIcon style={{ width: "1rem", height: "1rem" }} />
      {bloodTests.length} {bloodTestsPlurals(bloodTests.length)}
    </span>
  );
};
